import type { FC } from "react";
import {
    Accordion as _Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
} from "@ecco/ui/accordion";
import {
    accordionButtonStyles,
    accordionItemStyles,
} from "@components/cms/accordion/AccordionStyles";
import { Text } from "@ecco/ui/text";
import { H } from "@ecco/ui/a11y-heading";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { Box } from "@ecco/ui/box";
import type { AccordionModel } from "@lib/contentful/mappers/modules/accordion/types";

export const Accordion: FC<AccordionModel> = ({ header, accordionItems }) => (
    <Box px={[3, 4, 6]}>
        <H size="h5" textAlign="start" mb={[4, 4, 6]}>
            {header}
        </H>
        <Box maxW="888px" mx="auto">
            <_Accordion allowToggle w="full">
                {accordionItems.map((item) => (
                    <AccordionItem key={item.id} {...accordionItemStyles}>
                        <AccordionButton {...accordionButtonStyles}>
                            <Text
                                fontSize={{
                                    base: "mobileBodyTextSmall",
                                    lg: "desktopBodyTextSmall",
                                }}
                                fontWeight="bold"
                            >
                                {item.heading}
                            </Text>
                            <AccordionIcon data-testid="arrow-icon" w="1.5rem" h="1.5rem" />
                        </AccordionButton>
                        <AccordionPanel pl={0} pb={4}>
                            <Box fontSize="desktopBodyTextSmall">
                                <RichText data={item.text} options={{ variant: "accordion" }} />
                            </Box>
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </_Accordion>
        </Box>
    </Box>
);
